/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RankingEntry } from '../models/RankingEntry';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FantaRankingService {
    /**
     * Get Fanta Ranking
     * @param fantaTeamId
     * @param league
     * @param regionId
     * @param matchDay
     * @param fantaGroupId
     * @param limit
     * @param offset
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getFantaRanking(
        fantaTeamId: number,
        league: boolean = false,
        regionId?: (number | null),
        matchDay?: (number | null),
        fantaGroupId?: (number | null),
        limit: number = 10,
        offset?: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/fanta_ranking/',
            query: {
                'fanta_team_id': fantaTeamId,
                'league': league,
                'region_id': regionId,
                'match_day': matchDay,
                'fanta_group_id': fantaGroupId,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Fanta Ranking By Fanta Team Id
     * @param fantaTeamId
     * @param league
     * @param regionId
     * @param matchDay
     * @param fantaGroupId
     * @param halfLimit
     * @param offset
     * @returns RankingEntry Successful Response
     * @throws ApiError
     */
    public static getFantaRankingByFantaTeamId(
        fantaTeamId: number,
        league: boolean = false,
        regionId?: (number | null),
        matchDay?: (number | null),
        fantaGroupId?: (number | null),
        halfLimit: number = 10,
        offset?: number,
    ): CancelablePromise<Array<RankingEntry>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/fanta_ranking/{fanta_team_id}',
            path: {
                'fanta_team_id': fantaTeamId,
            },
            query: {
                'league': league,
                'region_id': regionId,
                'match_day': matchDay,
                'fanta_group_id': fantaGroupId,
                'half_limit': halfLimit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
